import React from 'react';
import Radium from 'radium';
import { Link } from 'react-router-dom';

import styles from './ServiceDetailStyle';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import MailCapture from '../../components/Mail/Mail';

class ServiceDetail extends React.Component {
    static getServiceHeading(serviceName) {
        if (serviceName === 'advisory') {
            return 'ADVISORY SERVICES'
        }
        else if (serviceName === 'workforce') {
            return 'WORKFORCE DEVELOPMENT SERVICES'
        }
        else if (serviceName === 'executive-development') {
            return 'EXECUTIVE DEVELOPMENT SERVICES'
        }
    }

    static getServiceText(serviceName) {
        if (serviceName === 'advisory') {
            return (
                <div>
                    <h4 style={styles.servicesHeader}>Improving the win ratio of deals</h4>
                    <p style={styles.servicesDesc}>
                        Winning large deal is crucial for growth of business and acquiring market share. With intense competition around, it is critical to continuously create a winning value proposition for clients.
                    </p>
                    <h4 style={styles.servicesHeader}>Increasing margins by focused initiatives on cost optimization</h4>
                    <p style={styles.servicesDesc}>
                        As the pricing gets aggressive, deal margins get impacted. How does one maintain competitive pricing and meet planned margins? It is absolutely essential for business leaders. There are several new methods thru which we can achieve cost optimization.
                        <br />
                        Automation is the most important area which will be a game changer. IT services delivery still has a very large % delivered using human resources. How does reduce Human resource component and tools replacing the human effort.
                    </p>
                    <h4 style={styles.servicesHeader}>Enhancing customer satisfaction through a series of programs</h4>
                    <p style={styles.servicesDesc}>
                        We have enough and more examples where we have won despite being higher priced or having offered more stringent terms and conditions than the competition. In other examples despite everything being equal, the customer comfort tilts the scale in favor of winner. How do create a culture and environment of customer delight across the company and sustain the same?
                    </p>
                    <div>
                        <Link to="/services" style={styles.serviceDetailLink}>
                            Back to all services
                            <i style={{ marginLeft: 10 }} className="fa fa-arrow-right"></i>
                        </Link>
                    </div>
                </div>
            )
        }
        else if (serviceName === 'workforce') {
            return (
                <div>
                    <h4 style={styles.servicesHeader}>Enhancing the capabilities of junior and middle management through customized development programs</h4>
                    <p style={styles.servicesDesc}>
                        While there has been a very high focus on leadership development, it is important to focus on middle management and junior management as well. There are two key reasons for same. Firstly, middle management and junior management run the core sales and delivery engine and their effectiveness can do wonders for the organization. Secondly it is critical to build succession plan and tap the young leaders early and groom them for future larger roles.
                    </p>
                    <h4 style={styles.servicesHeader}>Improving recruitment strategies for hiring niche talent across the globe</h4>
                    <p style={styles.servicesDesc}>
                        We all are aware that lack of right resources has a significant impact on business. There is a huge competition for resources in the market place. How does one deal with this ever growing problem?
                    </p>
                    <h4 style={styles.servicesHeader}>Enhancing employee engagement and retention</h4>
                    <p style={styles.servicesDesc}>
                        Call it a characteristic of Millennial or issue of demand supply, employee retention and employee engagement is one of the biggest challenge of Enterprises. We also know compensation is normally not the first reason of employee dissatisfaction. How does one go about enhancing employee engagement and retention?
                    </p>
                    <h4 style={styles.servicesHeader}>Improving the training strategy to minimize the learning curve</h4>
                    <p style={styles.servicesDesc}>
                        Lack of right resources gets compounded with high levels of attrition, low levels of employee engagement and ‘internal resources’ which are not suitable for the demand at hand.
                        <br />
                        To keep cost in check, enhance employee motivation, reduce cycle time to get resources and present tenured resources to your customers the only sustainable solution is to have an innovative and effective training strategy.
                    </p>
                    <div>
                        <Link to="/services" style={styles.serviceDetailLink}>
                            Back to all services
                            <i style={{ marginLeft: 10 }} className="fa fa-arrow-right"></i>
                        </Link>
                    </div>
                </div>
            );
        }
        else if (serviceName === 'executive-development') {
            return (
                <div>
                    <h4 style={styles.servicesHeader}>Overview</h4>
                    <p style={styles.servicesDesc}>
                        The IT executives have one of the best opportunity to make a great career. However, at times some of us feel that our peers have had a better career growth than us. Sometime we believe, we have not effectively marketed our work to our supervisors. In frustration, we sometime blame the system for not differentiating more capable and committed person.
                        <br />
                        If you ask me the real question to ask is "Do, I have the leadership capabilities better than my peers to get the dream role and position."?
                    </p>
                    <h4 style={styles.servicesHeader}>Personal Development</h4>
                    <p style={styles.servicesDesc}>
                        Over the years, I have met various executives who are not even aware of their strengths and area of improvements. Some executives are aware, however are not putting enough effort to improve the areas needing attention. Some executives those who want to put in effort are not very clear about what actions will help them improve their improvement areas.
                    </p>
                    <h4 style={styles.servicesHeader}>How we can help</h4>
                    <ul style={styles.serviceList}>
                        <li>Assessing strengths, improvement areas and areas which may prevent future growth</li>
                        <li>Developing a personal development plan to reinforce strengths and improve the areas which need attention</li>
                        <li>Coaching and mentoring to improve focus areas</li>
                    </ul>
                    <div>
                        <Link to="/services" style={styles.serviceDetailLink}>
                            Back to all services
                            <i style={{ marginLeft: 10 }} className="fa fa-arrow-right"></i>
                        </Link>
                    </div>
                </div>
            );
        }
    }

    render() {
        const serviceName = this.props.match.params.serviceName;
        return (
            <div>
                <Navbar />
                <div className="container" style={styles.container}>
                    <div className="row">
                        <div className="col-xs-12 text-center" style={{ marginBottom: 50 }}>
                            <h1 style={styles.servicesHeaderMain}>{ServiceDetail.getServiceHeading(serviceName)}</h1>
                        </div>
                        <div className="col-xs-12 col-md-8 col-md-offset-2">
                            {ServiceDetail.getServiceText(serviceName)}
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-10" style={{ marginBottom: 30, marginTop: 50 }}>
                        <MailCapture />
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Radium(ServiceDetail);


// WEBPACK FOOTER //
// ./src/containers/ServiceDetail/ServiceDetail.js